import ScalarLoading_default from "../ScalarLoading/ScalarLoading.vue.js";
import ScalarIconButton_default from "../ScalarIconButton/ScalarIconButton.vue.js";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createBlock, createCommentVNode, createElementBlock, createElementVNode, createVNode, defineComponent, guardReactiveProps, mergeModels, mergeProps, normalizeProps, openBlock, ref, unref, useModel, vModelText, withDirectives, withModifiers } from "vue";
import { ScalarIconMagnifyingGlass, ScalarIconX } from "@scalar/icons";
//#region src/components/ScalarSearchInput/ScalarSearchInput.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["aria-label", "placeholder"];
var ScalarSearchInput_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarSearchInput",
	props: /*@__PURE__*/ mergeModels({
		loader: {},
		label: {},
		placeholder: {},
		clearLabel: {}
	}, {
		"modelValue": {},
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		const model = useModel(__props, "modelValue");
		const inputRef = ref(null);
		function handleClear() {
			model.value = "";
			if (inputRef.value) inputRef.value.focus();
		}
		const { stylingAttrsCx, otherAttrs } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("label", normalizeProps(guardReactiveProps(unref(stylingAttrsCx)("flex items-center text-lg font-medium h-10 pl-3 pr-1.5 py-2 gap-2.25"))), [
				createVNode(unref(ScalarIconMagnifyingGlass), { class: "text-sidebar-c-search size-4" }),
				withDirectives(createElementVNode("input", mergeProps({
					ref_key: "inputRef",
					ref: inputRef
				}, unref(otherAttrs), {
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value = $event),
					"aria-label": __props.label ?? "Enter search query",
					autocapitalize: "off",
					autocomplete: "off",
					autocorrect: "off",
					class: "flex-1 appearance-none rounded border-none bg-transparent outline-none",
					placeholder: __props.placeholder ?? "Search...",
					spellcheck: "false",
					type: "search"
				}), null, 16, _hoisted_1), [[vModelText, model.value]]),
				__props.loader && __props.loader.isActive ? (openBlock(), createBlock(unref(ScalarLoading_default), {
					key: 0,
					class: "mr-1",
					loader: __props.loader,
					size: "lg"
				}, null, 8, ["loader"])) : model.value ? (openBlock(), createBlock(unref(ScalarIconButton_default), {
					key: 1,
					class: "-my-1",
					icon: unref(ScalarIconX),
					label: __props.clearLabel ?? "Clear Search",
					size: "sm",
					weight: "bold",
					onClick: withModifiers(handleClear, ["stop", "prevent"])
				}, null, 8, ["icon", "label"])) : createCommentVNode("", true)
			], 16);
		};
	}
});
//#endregion
export { ScalarSearchInput_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSearchInput.vue.script.js.map